import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  FormControlLabel,
  Checkbox,
  LinearProgress,
  Button,
} from '@material-ui/core';
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import { isArray, findIndex, assign, isUndefined, isNull } from 'lodash';
import moment from 'moment';
import qs from 'querystring';

import { CUSTOMIZACAO_RAIZEN } from '~/constants/modules';
import { t, can } from '~/helpers';
import api from '~/services/api';

import db from './db';
import * as S from './styles';
import Tabela from './Tabela';

export default function OperacaoAlinhamentoTanque() {
  const [post, setPost] = React.useState([]);
  const [virtual, setVirtual] = React.useState([]);
  const [fisico, setFisico] = React.useState([]);
  const [alinhamento, setAlinhamento] = React.useState(db);
  const [loading, setLoading] = React.useState(false);
  const [retroactive, setRetroactive] = useState(false);

  // const [dateTimeInitial, setDateTimeInitial] = useState(moment());
  const [dateTimeInitial, setDateTimeInitial] = useState(null);

  const profile = useSelector((state) => state.user.profile);

  const { alinhamaisdeumtanquefisico } = useSelector(
    (state) => state.user.configs
  );

  // Options (S~N)
  const options = React.useMemo(
    () => [
      { value: 'S', label: t('s.geral.opcoes.sim') },
      { value: 'N', label: '' },
    ],
    []
  );

  // Items já selecionados
  const defaultCheck = React.useMemo(
    () =>
      fisico
        .filter((item) => item.alinhadoestadotanquefisico === 'S')
        .map((item) => item.idtanquefisico),
    [fisico]
  );

  // Converter value in array
  const handleConvert = React.useCallback((value) => {
    const index = findIndex(options, (option) => option.value === value);

    if (index >= 0) return options[index].label;
    return value;
  }, []);

  // Cabeçalho postos
  const cellPost = React.useMemo(
    () => [
      {
        id: 'codigonomeposto',
        label: t('s.operacao.abastecimento.nomeposto'),
      },
    ],
    []
  );

  // Cabeçalho tanque virtual
  const cellVirtualTank = React.useMemo(
    () => [
      {
        id: 'idtanquevirtual',
        label: t('s.configuracao.tanquefisico.idtanquevirtual'),
      },
      {
        id: 'nomeproduto',
        label: t('s.cadastro.empresaveiculo.nomeproduto'),
      },
    ],
    []
  );

  // Cabeçalho tanque físico
  const cellPhysicalTank = React.useMemo(
    () => [
      {
        id: 'codigotanquefisico',
        label: t('s.configuracao.tanquefisico.codigotanquefisico'),
      },
      {
        id: 'alinhadoestadotanquefisico',
        label: t('s.operacao.alinhamentotanque.alinhadoestadotanquefisico'),
        converter: (value) => handleConvert(value),
      },
    ],
    []
  );

  // Buscar todos os postos na API.
  const handleResponseAPIPost = React.useCallback(async () => {
    try {
      const { data } = await api.get('postos?pagesize=9999');

      setPost(data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  // Busca tanques virtuais na API.
  const handleResponseAPIVirtual = React.useCallback(async (id) => {
    const params = {
      wherefield: ['idposto', 'statustanquevirtual'],
      valuewherefield: [id, 'L'],
      typewherefield: ['EQUALS', 'EQUALS'],
    };

    try {
      const { data } = await api.get('tanquesvirtuais', {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      });

      setVirtual(data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  // Busca de postos comboios na API.
  const handleResponseAPIFisico = React.useCallback(async (id, idVrtual) => {
    const params = {
      wherefield: ['idposto', 'statustanquefisico', 'idtanquevirtual'],
      valuewherefield: [id, 'L', idVrtual],
      typewherefield: ['EQUALS', 'EQUALS', 'EQUALS'],
    };

    try {
      const { data } = await api.get('estoquestanquespostoscomboios', {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      });

      setFisico(data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  // Callback posto
  const handleCallbackPosto = React.useCallback(
    (value) => {
      const { idposto } = value;

      handleResponseAPIVirtual(idposto);
      setVirtual([]);
      setFisico([]);
      setAlinhamento(assign(alinhamento, { idposto }));
    },
    [alinhamento]
  );

  // Callback tanque virtual
  const handleCallbackVirtual = React.useCallback(
    (value) => {
      const { idposto, idtanquevirtual, idproduto } = value;

      setFisico([]);
      handleResponseAPIFisico(idposto, idtanquevirtual);
      setAlinhamento(assign(alinhamento, { idtanquevirtual, idproduto }));
    },
    [alinhamento]
  );

  // Submit form
  const handleSubmit = React.useCallback(
    async (values) => {
      const idcliente = profile.client;
      const idusuario = profile.id;
      const tanques = values.map((value) => ({ idtanquefisico: value }));
      let objSend = assign(alinhamento, { idcliente, idusuario, tanques });

      if (can(CUSTOMIZACAO_RAIZEN) && retroactive) {
        if (isNull(dateTimeInitial)) {
          // toast.error('É necessário informar uma data/hora. ' + t('s.operacao.trocatanque.trocatanqueretroativo') + ' está habilitado!' );
          toast.error(
            t(
              's.operacao.alinhamentotanque.alinhamentoretroativohabilitadoseminformardata'
            )
          );
          return;
        }

        if (
          moment(dateTimeInitial, 'DD/MM/YYYY HH:mm:ss', true).isValid() ===
          false
        ) {
          toast.error(
            t(
              's.operacao.alinhamentotanque.alinhamentoretroativohabilitadoseminformardata'
            )
          );
          // toast.error('Data Invalida! É necessário informar uma data/hora. ' + t('s.operacao.trocatanque.trocatanqueretroativo') + ' está habilitado!' );
          return;
        }

        const datahorainicio = moment(dateTimeInitial).format(
          'DD/MM/YYYY HH:mm:ss'
        );

        objSend = {
          ...objSend,
          datahorainicioalinhamentotanquefisico: datahorainicio || null,
        };
      }
      setLoading(true);
      try {
        await api.post('alinhamentostanquesfisicos', objSend);
        await handleResponseAPIFisico(
          alinhamento.idposto,
          alinhamento.idtanquevirtual
        );

        toast.success(t('s.operacao.alinhamentotanque.alinhamentosucesso'));
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
        setLoading(false);
      }
    },
    [alinhamento, profile, dateTimeInitial, retroactive, CUSTOMIZACAO_RAIZEN]
  );

  // Start application
  React.useEffect(() => {
    handleResponseAPIPost();
  }, []);

  return (
    <S.Wrapper>
      {can(CUSTOMIZACAO_RAIZEN) && (
        <S.WrapperHeader>
          <S.WrapperFormInput>
            <FormControlLabel
              control={
                <Checkbox
                  checked={retroactive}
                  onChange={({ target }) => setRetroactive(target.checked)}
                  color="primary"
                />
              }
              label={t(
                's.operacao.alinhamentotanque.trocaalinhamentoretroativo'
              )}
            />
            {retroactive && (
              <KeyboardDateTimePicker
                ampm={false}
                format="DD/MM/YYYY HH:mm:ss"
                fullWidth
                disableFuture
                size="small"
                inputVariant="outlined"
                id="date-picker-initial"
                label={t('s.geral.opcoes.datahorainicial')}
                margin="normal"
                onChange={(value) => setDateTimeInitial(value)}
                required
                value={dateTimeInitial}
                disabled={loading}
                invalidDateMessage="Data inválida!"
              />
            )}
          </S.WrapperFormInput>
        </S.WrapperHeader>
      )}

      <S.WrapperTable>
        <Tabela
          title={t('s.configuracao.arqueacao.idposto')}
          cells={cellPost}
          data={post}
          size="small"
          height="75vh"
          clickOnCell={handleCallbackPosto}
        />

        <Tabela
          title={t('s.menu.cadastro.tanquevirtual.tanquevirtual')}
          cells={cellVirtualTank}
          data={virtual}
          size="small"
          height="75vh"
          clickOnCell={handleCallbackVirtual}
        />

        <Tabela
          radio={alinhamaisdeumtanquefisico === 'N'}
          checkbox={alinhamaisdeumtanquefisico !== 'N'}
          // radio={can(CUSTOMIZACAO_RAIZEN)}
          // checkbox={!can(CUSTOMIZACAO_RAIZEN)}
          title={t('s.menu.configuracao.tanquefisico')}
          cells={cellPhysicalTank}
          data={fisico}
          size="small"
          height="75vh"
          handleSubmit={handleSubmit}
          unique="idtanquefisico"
          loading={loading}
          defaultChecked={defaultCheck}
        />
      </S.WrapperTable>
    </S.Wrapper>
  );
}
